import React from 'react';
import MarkdownContent from '../../../../../../../../components/MarkdownContent/MarkdownContent';
import { WebsiteComponentInteractionPropType } from '../../../../../../../../services/proptypes';
var defaultProps = {};
function Markdown(_ref) {
  var element = _ref.element;
  var content = element.content;
  return /*#__PURE__*/React.createElement(MarkdownContent, {
    content: content
  });
}
Markdown.defaultProps = defaultProps;
export default Markdown;